import React, { Component } from "react";
import { CarouselWrapper, next, prev } from "react-pretty-carousel";

class PartnerSlider extends Component {
  render() {
    return (
      <div className="flex flex-col lg:flex-row justify-center items-center">
        <CarouselWrapper
          className="flex items-center"
          items={3}
          mode="gallery"
          showControls={false}
        >
          <img loading="lazy" src="./img/bni.png" alt="" />
          <img loading="lazy" src="./img/tsm.png" alt="" />
          <img loading="lazy" src="./img/abb.png" alt="" />
          <img loading="lazy" src="./img/pwc.png" alt="" />
          <img loading="lazy" src="./img/danone.png" alt="" />
          <img loading="lazy" src="./img/dep-pertanian.png" alt="" />
        </CarouselWrapper>
      </div>
    );
  }
}

export default PartnerSlider;
